import { getTestId } from '@airtel/air-design-system';
var tertiaryCtaData = {
  direction: 'row',
  leftCta: {
    buttonType: 'tertiary',
    title: 'tertiary cta',
    version: 'fixed-padding'
  },
  onLeftCtaPress: {
    id: 'tertiary-cta'
  }
};
var secondaryCtaData = {
  direction: 'row',
  leftCta: {
    buttonType: 'secondary',
    title: 'Remove +',
    version: 'fixed-padding'
  },
  onLeftCtaPress: {
    id: 'secondary-cta'
  }
};
export var defaultProps = Object.assign({
  title: 'Title here',
  subtitle: ' • Subtitle here',
  productName: 'Product name here',
  description: 'description text comes here',
  price: {
    newPrice: '₹9.80',
    oldPrice: '₹10.80',
    isOldPriceStriked: true,
    oldPricePostFix: 'GST'
  },
  deposit: {
    price: '₹10',
    postFix: 'security deposit'
  },
  arrayImagesUrl: ['https://engineering.fb.com/wp-content/uploads/2016/04/yearinreview.jpg', 'https://engineering.fb.com/wp-content/uploads/2016/04/yearinreview.jpg'],
  tertiaryCtaData: tertiaryCtaData,
  secondaryCtaData: secondaryCtaData,
  type: 'checkbox',
  ctaType: 'stepper',
  infoTagArray: [{
    text: 'info tag',
    subType: 'offer'
  }, {
    text: 'info tag',
    subType: 'offer'
  }, {
    text: 'info tag',
    subType: 'offer'
  }],
  stepperValue: '1',
  onIncrementButtonPressMetaData: {},
  onDecrementButtonPressMetaData: {},
  descriptionProps: {
    numberOfLines: 0
  },
  isDisabled: false,
  productNameAccessibilityProps: {
    accessibilityLabel: '₹599 per month'
  }
}, getTestId('AddOnWidgetContainer'));